import { Flex, Text } from '@chakra-ui/react';
import { Button, Modal } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/pro-light-svg-icons';
import { IInviteReviewer } from './commonTypes';
import { useReviewerInviteList } from '../../../../contexts/ReviewerInviteListProvider';

interface Props {
  onClose: () => void;
  onInviteReviewers: () => void;
  isProcessing: boolean;
  option: 'invite' | 'queue';
}

const ConfirmInviteModal = ({
  onClose,
  onInviteReviewers,
  isProcessing,
  option
}: Props) => {
  const { reviewerList, selectedReviewersToInvite } = useReviewerInviteList();

  const confirmedReviewers = reviewerList.filter(
    r => selectedReviewersToInvite[r.email] && !r.invited
  );

  const inviteNowReviewers = confirmedReviewers;
  const addToQueueReviewers = confirmedReviewers;

  const heading =
    option === 'invite' ? 'Invite Reviewers?' : 'Add Reviewers to the Queue?';
  const description =
    option === 'invite'
      ? 'You will send invites to the following Reviewers:'
      : `You will add the following reviewers to the queue:`;

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      width="448px"
      closeButtonProps={{
        hidden: true
      }}
    >
      <Flex flexDirection="column" gap={6} padding={8}>
        <FontAwesomeIcon
          icon={faEnvelope}
          style={{ width: '40px', height: '40px' }}
        />

        <Flex flexDirection="column" gap={2} tabIndex={1}>
          <Text textStyle="headingGroup">{heading}</Text>
          <Text textStyle="textBody">{description}</Text>
        </Flex>

        <Flex flexDirection="column" gap={4}>
          {option === 'invite' && inviteNowReviewers.length > 0 && (
            <ul>
              {inviteNowReviewers.map((reviewer: IInviteReviewer) => (
                <li key={reviewer.email}>
                  <Text textStyle="textContext">{reviewer.email}</Text>
                </li>
              ))}
            </ul>
          )}

          {option === 'queue' && addToQueueReviewers.length > 0 && (
            <ul>
              {addToQueueReviewers.map((reviewer: IInviteReviewer) => (
                <li key={reviewer.email}>
                  <Text textStyle="textContext">{reviewer.email}</Text>
                </li>
              ))}
            </ul>
          )}
        </Flex>

        <Flex justifyContent="flex-end" gap={2}>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={onInviteReviewers}
            disabled={isProcessing}
            isLoading={isProcessing}
          >
            {option === 'invite'
              ? 'Invite Reviewers'
              : 'Add Reviewers to Queue'}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default ConfirmInviteModal;
